/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * Component for page forbidden routing
 *
 * @author Yakov Gushchin
 * @version 1.11.0
 * @since 1.11.0
 */

import { AccessComponentKeyEnum } from '../../modules/role/constants/guard/guardConstants';
import Guard from '../../modules/role/Guard';
import PageForbidden from '../../pages/ErrorPage/PageForbidden';

const ForbiddenRoute = () => {
    return (
        <Guard accessKey={AccessComponentKeyEnum.PageForbidden}>
            <PageForbidden/>
        </Guard>
    );
};

export default ForbiddenRoute;
